import { PageLayout } from 'src/ui/common/layouts/page-layout';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const LandingPageLayout = styled(PageLayout)`
    padding: 0 10px;

    ${media.sm`
        padding: 0 40px;
    `}
`;
